import React, { useState } from "react";
import Typography from "@material-ui/core/Typography";
import Swipeable from "../../../../Fronts/Main/Swipeable";
import Grid from "@material-ui/core/Grid";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Divider from "@material-ui/core/Divider";
import { Button, Hidden, TextField } from "@material-ui/core";
import CheckboxItem, { useStylesAcc } from "../CheckBoxComponent";
import { Autocomplete } from "@material-ui/lab";
import { GetItemFromOptions } from "../../../../services/global-services";
import { useTranslation } from "react-i18next";
const formData = [

    {
        name: "used_shifts_trans",
        label: "force-use-shifts",
        visible: true,
    },
    {
        name: "used_shifts_transOpen",
        label: "allow-open-shifts",
        visible: true,
    },
    {
        name: "used_shifts_transClose",
        label: "allow-close-shifts",
        visible: true,
    },
    {
        name: "show_only_shiftcash",
        label: "show-received-cash-only-on-shift-close",
        visible: true,
      },

];

export default function ShiftsPermission(props) {
    const { onChange, object, accounts } = props;
    const { t } = useTranslation(["forms"]);
    const accs = accounts.filter((obj) => parseFloat(obj.id)> 1234);
    const [Accounts, setAccounts] = useState(() => {
        return [{ id: -1, name: "no" }, ...accs];
    });
    const valueCloseAcc = GetItemFromOptions(object?.shift_trans_close_acc_no ?? -1, Accounts);
    const valuePlusAcc = GetItemFromOptions(object?.shift_trans_plus_acc_no ?? -1, Accounts);
    const valueMinAcc = GetItemFromOptions(object?.shift_trans_minus_acc_no ?? -1, Accounts);

    const getoptionCustomers = (option) => {
        return `${option?.name + '  ' + option?.id ?? ""}`
      };
    
    const classes = useStylesAcc();

    return (
        <div className={classes.root}>
            <Accordion expanded={true}>
                <AccordionDetails>
                    <Grid item container spacing={1}>
                        {formData
                            ?.filter((d) => d.visible)
                            ?.map((item) => {
                                return (
                                    <Grid xs={6}>
                                        <CheckboxItem
                                            value={object[item.name] ?? null}
                                            name={item.name}
                                            label={t(item.label)}
                                            onChange={onChange}
                                        />
                                    </Grid>
                                );
                            })}
                    </Grid>
                </AccordionDetails>
                <Grid container lg={12} md={12} sm={12} xs={12} spacing={1}>
                    <Grid item lg={2} md={2} sm={6} xs={6} >
                        <div style={{ fontWeight: "bold", fontSize: "1rem" }}>{t("shift-transfer-cashbox-account")}</div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={6} xs={6} >
                        <Autocomplete
                            value={valueCloseAcc}
                            onChange={(event, newValue) => {
                                onChange(null, {
                                    name: "shift_trans_close_acc_no",
                                    value: newValue?.id,
                                });
                            }}
                            id="apply_discount"
                            size="small"
                            options={Accounts}
                            getOptionLabel={(option) =>
                                getoptionCustomers(option)
                            }
                            style={{}}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputLabelProps={{ shrink: true }}
                                    label={t("shift-transfer-cashbox-account")}
                                    variant="outlined"
                                />
                            )}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12} >
                        <div style={{ fontWeight: "bold", fontSize: "1rem" }}>{t("employee-cashbox-transfer-target")}</div>
                    </Grid>
                    <Grid item lg={2} md={2} sm={6} xs={6} >
                        <div style={{ fontWeight: "bold", fontSize: "1rem" }}>{t("surplus-account")}</div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={6} xs={6} >
                        <Autocomplete
                            value={valuePlusAcc}
                            onChange={(event, newValue) => {
                                onChange(null, {
                                    name: "shift_trans_plus_acc_no",
                                    value: newValue?.id,
                                });
                            }}
                            id="shift_trans_plus_acc_no"
                            size="small"
                            options={Accounts}
                            getOptionLabel={(option) =>
                                getoptionCustomers(option)
                            }
                            style={{}}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputLabelProps={{ shrink: true }}
                                    label={t("surplus-account")}
                                    variant="outlined"
                                />
                            )}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12} >
                        <div style={{ fontWeight: "bold", fontSize: "1rem" }}>{t("surplus-transfer-target")}</div>
                    </Grid>
                    <Grid item lg={2} md={2} sm={6} xs={6} >
                        <div style={{ fontWeight: "bold", fontSize: "1rem" }}>{t("deficit-account")}</div>
                    </Grid>
                    <Grid item  lg={4} md={4} sm={6} xs={6}>
                        <Autocomplete
                            value={valueMinAcc}
                            onChange={(event, newValue) => {
                                onChange(null, {
                                    name: "shift_trans_minus_acc_no",
                                    value: newValue?.id,
                                });
                            }}
                            id="shift_trans_minus_acc_no"
                            size="small"
                            options={Accounts}
                            getOptionLabel={(option) =>
                                getoptionCustomers(option)
                            }
                            style={{}}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputLabelProps={{ shrink: true }}
                                    label={t("deficit-account")}
                                    variant="outlined"
                                />
                            )}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12} >
                        <div style={{ fontWeight: "bold", fontSize: "1rem" }}>{t("deficit-transfer-target")}</div>
                    </Grid>
                </Grid>
            </Accordion>
            <Swipeable />
        </div>
    );
}
